<template>
  <drop-helper :dropOptions="dropOptions"></drop-helper>
</template>

<script>
import DropHelper from '@/components/DragDrop/DropHelper';
import { mapGetters, mapState, mapActions } from 'vuex';

export default {
  components: { DropHelper },
  props: ['item', 'page', 'preventDrop', 'viewMode'],
  data() {
    return {
      accepts: ['noteCard', 'noteBlock'],
      firstDraggedItem: null,
      idsToMove: [],
      savedDragData: null
    };
  },
  watch: {
    draggedItems: function(n, o) {
      if (n[0]) {
        //  store the value of dragged data so when drag stops we still have it to execute on
        this.firstDraggedItem = n[0];
        this.idsToMove = this.draggedData.ids;
        this.savedDragData = this.draggedData;
        console.log(this.firstDraggedItem, n);
      }
    }
  },
  computed: {
    ...mapGetters('pages', ['selectedPageNotes']),
    ...mapState('views/context', ['selectedPageId']),
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapState('components/dragdrop', ['draggedData']),
    dropOptions() {
      return {
        accepts: this.accepts,
        zones: [
          //  handle sorting questions
          {
            id: 'sortAbove',
            show: this.viewMode == 'full' && this.isSortable && !this.isNextItemDown,
            style: {
              top: 0,
              left: 0,
              right: 0,
              height: 'auto',
              bottom: this.isNextItemUp ? 0 : '49%'
            },
            hoverWidth: 100,
            hoverClass: 'q-dropzone-top',
            onDrop: () => this.moveItem(this.isSortingDown ? -1 : 0)
          },
          {
            id: 'sortBelow',
            show: this.viewMode == 'full' && this.isSortable && !this.isNextItemUp,
            style: {
              top: this.isNextItemDown ? '1px' : '52%',
              height: 'auto',
              left: 0,
              right: 0,
              bottom: 0
            },
            hoverWidth: 100,
            hoverClass: 'q-dropzone-bottom',
            onDrop: () => this.moveItem(this.isSortingUp ? 1 : 0)
          },
          {
            id: 'sortLeft',
            show: this.viewMode == 'grid' && this.isSortable && !this.isNextItem,
            style: {
              top: 0,
              left: '-8px',
              right: this.isPreviousItem ? 0 : '49%',
              height: 'auto',
              bottom: 0
            },
            hoverWidth: 100,
            hoverClass: 'q-dropzone-left',
            targetCursor: true,
            onDrop: () => this.moveItem(this.isSortingDown ? -1 : 0)
          },
          {
            id: 'sortRight',
            show:
              this.viewMode == 'grid' && this.isSortable && !this.isPreviousItem && this.item.id,
            style: {
              top: 0,
              height: 'auto',
              left: this.isNextItem ? '1px' : '52%',
              right: '-8px',
              bottom: 0
            },
            hoverWidth: 100,
            targetCursor: true,
            hoverClass: 'q-dropzone-right',
            onDrop: () => this.moveItem(this.isSortingUp ? 1 : 0)
          },
          {
            id: 'dropNote',
            show: false && this.isDroppable,
            hide: this.preventDrop,
            style: {
              top: '10px',
              left: 0,
              right: 0,
              bottom: '10px'
            },
            hoverClass: 'q-dropzone-merge',
            hoverWidth: 100,
            zoneText: '',
            zoneIcon: '',
            zoneClass: 'zone-merge',
            //hoverClass: 'hover-zone-move',
            onDrop: () => this.moveNote()
          }
        ]
      };
    },
    active() {
      const matchedAccepts = this.accepts.filter(value => this.draggedData.types.includes(value));
      return this.dragging && matchedAccepts.length > 0;
    },
    draggedItems() {
      if (!this.active) {
        return [];
      }
      return this.draggedData.items;
    },
    isDragged() {
      return this.active && this.draggedData.ids.includes(this.item.id);
    },
    isSortable() {
      return this.active && !this.isDragged && this.draggedData.types.includes('noteCard');
    },
    isDroppable() {
      return (
        this.active &&
        !this.isDragged &&
        this.draggedData.types.includes('noteBlock') &&
        !this.isParentCard
      );
    },
    isParentCard() {
      return (
        this.draggedData.types.includes('noteBlock') &&
        this.draggedData.items &&
        this.draggedData.items[0].cardId == this.item.id
      );
    },
    isSortingUp() {
      return this.item.order < this.firstDraggedItem.order;
    },
    isSortingDown() {
      return this.item.order > this.firstDraggedItem.order;
    },
    isNextItemUp() {
      const firstDraggedItem = this.firstDraggedItem || [];
      return firstDraggedItem.order - 1 == this.item.order;
    },
    isNextItemDown() {
      const lastDraggedItem = this.draggedItems[this.draggedItems.length - 1] || [];
      return lastDraggedItem.order + 1 == this.item.order;
    }
  },
  methods: {
    ...mapActions('pages', ['moveCard', 'moveNoteById']),
    moveItem(offsetOrder = 0) {
      this.moveCard({
        fromPageId: this.savedDragData.parent.id,
        toPageId: this.selectedPageId,
        cardId: this.idsToMove[0],
        order: this.item.order + offsetOrder
      });
    },
    moveNote() {
      const noteIds = this.idsToMove;
      const moveToPosition = Object.values(this.page.pageNotes).filter(
        n => n.cardId == this.item.id && !n.toDelete
      ).length;
      const pageId = this.page.id;
      const moveFromCardId = this.firstDraggedItem.cardId;
      const moveToCardId = this.item.id;
      this.moveNoteById({ noteIds, moveToCardId, moveFromCardId, moveToPosition, pageId });
    }
  }
};
</script>

<style>
.q-dropzone-top {
  border-top: 3px solid #2196f3;
}

.q-dropzone-bottom {
  border-bottom: 3px solid #2196f3;
  margin-bottom: -3px;
}
.q-dropzone-merge {
  background: #2195f345;
}

.zone-merge .drop-zone-content {
  opacity: 0;
  color: #242424;
  font-weight: bold;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.76);
  transition: 0.5s ease all;
}

.zone-merge.hover .drop-zone-content {
  opacity: 1;
  color: #242424;
  font-weight: bold;
  border-radius: 2px;
  background: rgba(255, 255, 255, 0.76);
  transition: 0.5s ease all;
}
</style>
